module.exports = __webpack_public_path__ + "img/walletioft.def745c1.png";